import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from './router'
import store from './store/store.js';

Vue.use(AclInstaller)


// NOTE: Set initial role & update when user login details & role is found in LocalStorage
let initialRole = 'guest';
if (JSON.parse(localStorage.getItem('userDetails')) && JSON.parse(localStorage.getItem('userDetails')).role) initialRole = JSON.parse(localStorage.getItem('userDetails')).role;

export default new AclCreate({
  initial: initialRole,
  notfound: {
    // NOTE: If user is logged in & has no permission, redirect to 404, else to login
    path: JSON.parse(localStorage.getItem('userDetails')) ? '/error-404' : '/login',
    forwardQueryParams: true,
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    // NOTE: Will change when multiple roles are assigned to a user
    // Master rules start
    isSuperAdmin: new AclRule('superadmin').generate(),
    isChannelAdmin: new AclRule('channel_admin').or('superadmin').generate(),
    isChannelUser: new AclRule('channel_user').or('channel_admin').or('superadmin').generate(),
    isBIAdmin: new AclRule('bi_admin').or('superadmin').generate(),
    isBIUser: new AclRule('bi_user').or('bi_admin').or('channel_admin').or('superadmin').generate(),
    isGuest: new AclRule('guest').or('bi_user').or('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    // Master rules end

    // Custom rules start
    // isAllowedToViewResellers: new AclRule('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    // isAllowedToAddPromo: new AclRule('channel_user').or('bi_admin').or('channel_admin').or('superadmin').generate(),
    // // TODO: Remove any one of the below
    // isAllowedToViewRebates: new AclRule('bi_user').or('channel_user').or('bi_admin').or('channel_admin').or('superadmin').generate(),
    // isAllowedToAddAndEditPartners: new AclRule('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    // // isLogged: new AclRule('user').and('inside').generate()

    isAllowedToViewResellers: new AclRule('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    isAllowedToAddPromo: new AclRule('channel_user').or('bi_admin').or('channel_admin').or('superadmin').generate(),
    // TODO: Remove any one of the below
    isAllowedToViewRebates: new AclRule('bi_user').or('channel_user').or('bi_admin').or('channel_admin').or('superadmin').generate(),
    isAllowedToViewDashboard: new AclRule('bi_user').or('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    isGuest: new AclRule('guest').or('bi_user').or('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    isAllowedToAddAndEditPartners: new AclRule('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    // TODO: Make GetDisableCNICFlag work
    isAllowedToAddAndEditRegistrars: !store.getters.getDisableCNICFlag && new AclRule('bi_admin').or('channel_user').or('channel_admin').or('superadmin').generate(),
    // Custom rules end
  },
  // NOTE: This has no effect, whatsoever on the acl (Doesn't work)
  middleware: async acl => {
    if(JSON.parse(localStorage.getItem('userDetails')) && JSON.parse(localStorage.getItem('userDetails')).role) {
      acl.change(JSON.parse(localStorage.getItem('userDetails')).role);
    }
  }
})